import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@interfaces/Category';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'internalFeeBillable'
})
export class InternalFeeBillablePipe implements PipeTransform {
  public transform(element: DepartmentEstimate | Category): number {
    return element.estimateLines.reduce(
      (billable, estimateLine) =>
        billable +
        estimateLine.internalFeeLines.map(l => l.quantity * l.rateBillable).reduce((sum, element) => sum + element, 0),
      0
    );
  }
}
